var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "85E3F5E0-E9C6-43D5-AFD7-3CA4D3D5A972") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enclosures-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AMFG-Enclosures-OnePager-v1",
    transform: "translate(-1037.000000, -12840.000000)",
    fill: "#E9E9E9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer",
    transform: "translate(0.000000, 12764.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1037.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-facebook-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,0 C9.8505,0 0,9.8505 0,22 C0,34.1495 9.8505,44 22,44 C34.1495,44 44,34.1495 44,22 C44,9.8505 34.1495,0 22,0 Z M27.5,14.6666667 L25.025,14.6666667 C24.0386667,14.6666667 23.8333333,15.0718333 23.8333333,16.093 L23.8333333,18.3333333 L27.5,18.3333333 L27.1168333,22 L23.8333333,22 L23.8333333,34.8333333 L18.3333333,34.8333333 L18.3333333,22 L14.6666667,22 L14.6666667,18.3333333 L18.3333333,18.3333333 L18.3333333,14.102 C18.3333333,10.8588333 20.0401667,9.16666667 23.8865,9.16666667 L27.5,9.16666667 L27.5,14.6666667 Z",
    id: "Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.6b5dc0c5ea5e06de6f937e40b826ab10.svg";
export { ForwardRef as ReactComponent };